import { lighten, styled } from '@material-ui/core';

const ReactDatePickerStyled = styled('div')(({ theme }) => {
  const isDark = theme.palette.type === 'dark';
  return {
    display: 'flex',
    fontSize: '0.8rem',
    '& .calendar-left-panel .MuiTypography-root': {
      fontSize: '0.944rem',
    },
    '& .datepicker': {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.paper,
    },
    '& .footer': {
      maxWidth: '418px',
    },
    '&.nowrap .react-datepicker': {
      display: 'flex',
      flexWrap: 'nowrap',
    },
    '& .react-datepicker': {
      fontFamily: 'inherit',
      border: 0,
      padding: 2,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
    },
    '& .react-datepicker__header': {
      backgroundColor: 'transparent',
      border: 0,
      textTransform: 'capitalize',
      color: theme.palette.text.primary,
    },
    '& .react-datepicker__navigation': {
      top: 15,
    },
    '& .react-datepicker__navigation-icon::before': {
      borderColor: isDark ? theme.palette.grey[400] : theme.palette.grey[800],
      borderWidth: '1px 1px 0 0 !important',
    },
    '& .react-datepicker__navigation-icon:hover::before': {
      borderColor: theme.palette.grey[500],
    },
    '& .react-datepicker__current-month': {
      fontWeight: 500,
      paddingBlock: 8,
      color: theme.palette.text.primary,
    },
    '& .react-datepicker__month-container': {
      minHeight: 255,
    },
    '& .react-datepicker__day-name': {
      color: isDark ? theme.palette.grey[400] : theme.palette.grey[600],
      margin: 0,
      padding: 0,
      width: '2rem',
    },
    '& .react-datepicker__week': {
      display: 'flex',
      marginBlock: 2,
    },
    '& .react-datepicker__day, .react-datepicker__day:hover': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 0,
      padding: 0,
      width: '2rem',
      height: '2rem',
      borderRadius: 8,
      backgroundColor: 'transparent',
      color: theme.palette.text.primary,
    },
    '& .react-datepicker__day--today': {
      fontWeight: 700,
      backgroundColor: isDark
        ? theme.palette.grey[700]
        : theme.palette.grey[300],
      borderRadius: 20,
    },
    '& .react-datepicker__day--keyboard-selected:hover, .react-datepicker__day:hover':
      {
        boxShadow: `0 0 0 2px ${lighten(
          theme.palette.primary.light,
          0.4
        )} inset`,
      },
    '& .react-datepicker__day:hover, & .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range)':
      {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.light,
      },
    '& .react-datepicker__day--in-range, .react-datepicker__day--in-selecting-range':
      {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.light,
        borderRadius: 0,
      },
    '& .react-datepicker__day.react-datepicker__day--selected': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.light,
    },
    '& .react-datepicker__day--in-range.react-datepicker__day--range-end, .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-end':
      {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 0,
        borderTopRightRadius: 8,
        borderBottomRightRadius: 8,
      },
    '& .react-datepicker__day--in-range.react-datepicker__day--range-start, .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start':
      {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 0,
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,
      },
    '& .react-datepicker__day--selected.react-datepicker__day--range-end, .react-datepicker__day--in-selecting-range.react-datepicker__day--in-selecting-range-start.react-datepicker__day--in-selecting-range-end':
      {
        borderRadius: 8,
      },
    '& .react-datepicker__day--disabled, & .react-datepicker__day--disabled:hover':
      {
        color: theme.palette.text.disabled,
        backgroundColor: 'transparent',
        cursor: 'default',
        boxShadow: 'none',
      },
    '& .react-datepicker__day--outside-month': {
      opacity: 0.7,
    },
    '& .react-datepicker__day--outside-month:empty': {
      pointerEvents: 'none',
      opacity: 0.2,
    },
    '& .react-datepicker__time-container, & .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ':
      {
        width: 110,
      },
    '& .react-datepicker__time-container': {
      borderLeftColor: theme.palette.divider,
      backgroundColor: theme.palette.background.paper,
    },
    '& .react-datepicker__time-container .react-datepicker__time': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .react-datepicker__header.react-datepicker__header--time': {
      backgroundColor: theme.palette.background.paper,
      borderBottomColor: theme.palette.divider,
    },
    '& .react-datepicker-time__header': {
      color: theme.palette.text.primary,
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item':
      {
        height: 15,
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
        fontFamily: 'inherit',
        color: theme.palette.text.primary,
      },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover':
      {
        backgroundColor: theme.palette.action.hover,
      },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected':
      {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover':
      {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
      },
  };
});

export default ReactDatePickerStyled;
